import React, { useState } from "react"
import { Row, Label, Input } from "reactstrap"

const DPTextBoxAlign = ({
  rowClass,
  labelText,
  textType,
  value,
  onChange,
  placeholder,
  defaultValue,
}) => {
  return (
    <Row className={rowClass}>
      <Label
        htmlFor="example-text-input"
        className="col-md-4 col-form-label-sm"
      >
        {labelText}
      </Label>
      <div className="col-md-2">
        <input
          className="form-check-input"
          type="checkbox"
          value=""
          id="defaultCheck1"
        />
      </div>
    </Row>
  )
}

export default DPTextBoxAlign
